<template>
  <v-app>
    <v-content>
      <snackbar-store />
     <router-view/>
    </v-content>
  </v-app>
</template>
<script>

import snackbarStore from '@/components/Reusable/SnackbarStore'

export default {
  name: 'App',
  components: {
    snackbarStore
  },
  data: () => ({
    drawer: false,
  }),
};
</script>
